import React, { useCallback } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";

import { Layout, Form, Button, Typography, Image } from "antd";

import Logo from "@tokens/Assets/web/img/logo/01_standard.png";
import "./Login.less";

const KC_IDP_HINT = process.env.REACT_APP_KC_IDP_HINT || "";
const KC_HAS_EXTERNAL_IDP = process.env.REACT_APP_KC_HAS_EXTERNAL_IDP === "true";

const Login = () => {
  const [form] = Form.useForm();

  const { keycloak } = useKeycloak();
  const { t } = useTranslation();

  const login = useCallback(
    idpHint => {
      keycloak?.login({ idpHint });
    },
    [keycloak],
  );

  return (
    <Layout className="Login__layout">
      <Form form={form} name="login" className="form__login">
        <Image preview={false} src={Logo} />
        <Typography.Title style={{ marginBottom: "0" }} level={4} strong>
          {t("Welcome")}
        </Typography.Title>

        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
          <Button block type="primary" size="large" onClick={() => login(KC_IDP_HINT)}>
            {t("Login")}
          </Button>

          {!!KC_HAS_EXTERNAL_IDP && (
            <Button block onClick={() => login("")}>
              {t("External")}
            </Button>
          )}
        </div>
      </Form>
    </Layout>
  );
};

export default Login;
